import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';
import './i18n';

import App from 'App';
import { AuthService } from 'services/authService';

const Index: React.FC = () => (
	<BrowserRouter>
		<React.StrictMode>
			<MsalProvider instance={AuthService.instance}>
				<App />
			</MsalProvider>
		</React.StrictMode>
	</BrowserRouter>
);

ReactDOM.render( <Index />, document.getElementById('root'));
